'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('housing_protection', {
      url: '/account/housing/housing_protection?jurisdiction&sta_recid&policyName',
      template: '<housing-protection></housing-protection>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null,     // Default value if not provided
        policyName: null     // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/housing/housing_protection/housing_protection.routes.js